import React from 'react';
import { useCredits } from '../../hooks/useCredits';

const LOW_BALANCE_THRESHOLD = 100;

interface LowBalanceBannerProps {
  className?: string;
}

const LowBalanceBanner: React.FC<LowBalanceBannerProps> = ({ className = '' }) => {
  const { balance, loaded } = useCredits();
  if (!loaded || balance >= LOW_BALANCE_THRESHOLD) return null;

  return (
    <div
      role="alert"
      className={`rounded border border-amber-500/40 bg-amber-500/10 text-amber-200 text-xs px-3 py-2 flex items-center gap-2 ${className}`}
    >
      <span aria-hidden>⚡</span>
      <span>
        Low credit balance ({balance.toLocaleString()}). Generations may fail with 402. Ask an admin to top up.
      </span>
    </div>
  );
};

export default LowBalanceBanner;
